import { jsxs as r, jsx as s } from "react/jsx-runtime";
import { useRef as j, useEffect as x } from "react";
import { getTabsStyles as y } from "./tools.js";
import { motion as g } from "framer-motion";
import { LockIcon as k } from "../Common/LockIcon.js";
const I = ({
  tab: o,
  value: l,
  index: a,
  layoutId: c,
  isHoverOnLeft: m,
  isHoverOnRight: u,
  onChange: p,
  handleResetIsHover: t,
  handleSetIsHover: f,
  ...d
}) => {
  const n = j(null), e = l.value === o.value, { optionButton: b, optionPill: v, optionLabel: h } = y({
    ...d,
    active: e
  });
  return x(() => {
    var i;
    e && ((i = n.current) == null || i.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center"
    }));
  }, [e]), /* @__PURE__ */ r(
    "button",
    {
      type: "button",
      ref: n,
      disabled: o.disabled,
      onClick: () => {
        p(o), t();
      },
      onMouseEnter: () => {
        e || f(a);
      },
      onMouseLeave: () => t(),
      className: b(),
      children: [
        e && /* @__PURE__ */ s(
          g.span,
          {
            layoutId: c,
            className: `${v()} ${m && "-jm-right-2"} ${u && "-jm-left-2"}`,
            transition: {
              type: "easeInOut",
              duration: 0.3
            },
            style: { originY: "0px" }
          }
        ),
        /* @__PURE__ */ r("span", { className: h(), children: [
          o.disabled && /* @__PURE__ */ s(k, {}),
          o.label
        ] })
      ]
    },
    o.label
  );
};
export {
  I as TabButton
};
//# sourceMappingURL=TabButton.js.map
